import { cva } from "class-variance-authority";

/**
 * The pill field of the date and time pickers: 32px high, radius 25px, a green ring while its picker is open,
 * a red border on an error and a grey fill when it cannot be changed. 44px with 16px text on a phone.
 */
export const fieldFrameCva = cva(
  "relative flex w-full min-w-0 items-center rounded-[25px] border bg-white transition-colors dark:bg-dark-800 max-sm:h-11 max-sm:text-base",
  {
    variants: {
      size: {
        small: "h-7 text-sm",
        medium: "h-8 text-sm",
        large: "h-10 text-base",
      },
      state: {
        idle: "border-gray-300 hover:border-gray-400 focus-within:border-primary-400 focus-within:shadow-[0_0_0_1px] focus-within:shadow-primary-400 dark:border-dark-600",
        open: "border-primary-400 shadow-[0_0_0_1px] shadow-primary-400",
        error: "border-danger-600 dark:border-danger-500",
        disabled: "border-gray-200 bg-gray-50 dark:border-dark-700 dark:bg-dark-900",
      },
    },
    defaultVariants: {
      size: "medium",
      state: "idle",
    },
  },
);

export const fieldInputCva = cva(
  "h-full min-w-0 flex-1 rounded-[25px] border-0 bg-transparent pr-2 pl-[37px] text-[length:inherit] tabular-nums outline-hidden placeholder:text-gray-400 dark:placeholder:text-dark-400",
  {
    variants: {
      disabled: {
        true: "cursor-not-allowed text-gray-500",
        false: "text-gray-900 dark:text-gray-100",
      },
    },
    defaultVariants: {
      disabled: false,
    },
  },
);

export const fieldClearCva = cva(
  "mr-1 inline-flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full p-0 text-gray-500 hover:bg-gray-100 hover:text-gray-800 focus-visible:outline-2 focus-visible:outline-primary-500 dark:hover:bg-dark-700 dark:hover:text-gray-200 max-sm:size-9",
);
